export default "__VITE_PUBLIC_ASSET__10369764__"